import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { downloadCsv, DownloadCsvQueries } from '../../services/apiSLTP/download';

type DownloadCsvMutationOptions = MutationOptions<void, Error, { exportType: number; queries: DownloadCsvQueries }>;

export const useDownloadCsvMutation = (options?: DownloadCsvMutationOptions) => {
    const downloadCsvMutation: MutationFunction<void, { exportType: number; queries: DownloadCsvQueries }> = async ({ exportType, queries }) => {
        await downloadCsv(exportType, queries);
    };

    return useMutation(downloadCsvMutation, options);
};
